import { Box, Collapse, List, ListItemButton, ListItemText } from '@mui/material';
import { capitalize } from 'lodash';
import { useEffect, useState } from 'react';
import { useAutoAnimate } from '@formkit/auto-animate/react';
import { useMenuContext } from '../../context';

type Props = {
  label: string;
  children: React.ReactNode;
  gutterLeft?: number;
  uncollapse?: boolean;
};

export default function MenuSection({ label, children, uncollapse, gutterLeft }: Props) {
  const { colors, settings, open } = useMenuContext();
  const [isOpen, setIsOpen] = useState(false);
  const [parent, enableAnimations] = useAutoAnimate();

  // To have the items present right away when the menu is opened instead of waiting for the animation to finish
  useEffect(() => {
    if (open) {
      enableAnimations(false);
      setTimeout(() => {
        enableAnimations(true);
      }, 500);
    }
  }, [enableAnimations, open]);
  useEffect(() => {
    if (settings.categoryExpand || uncollapse) setIsOpen(true);
    else setIsOpen(false);
  }, [settings.categoryExpand, uncollapse]);

  return (
    <List disablePadding>
      <ListItemButton
        sx={{
          ...(gutterLeft && { paddingLeft: `${gutterLeft}px` }),
          background: isOpen ? colors.open : 'transparent',
        }}
        onClick={() => setIsOpen(!isOpen)}
      >
        <ListItemText primary={capitalize(label)} />
        <i
          className="far fa-angle-down"
          style={{
            transform: isOpen ? 'rotate(0deg)' : 'rotate(-90deg)',
            transition: 'transform 0.3s',
          }}
        />
      </ListItemButton>
      <Collapse in={isOpen}>
        <Box ref={parent} sx={{ overflow: 'hidden' }}>
          {children}
        </Box>
      </Collapse>
    </List>
  );
}
